(function () {
  // Global interceptor for Add to Cart to enforce custom fabric logic (fixes Swym and other apps)
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    let url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
    if (url && (url.includes('/cart/add.js') || url.includes('/cart/add'))) {
      try {
        let options = args[1] || {};
        if (options.body) {
          if (typeof options.body === 'string') {
            try {
              let data = JSON.parse(options.body);
              let modified = false;
              if (data.items && Array.isArray(data.items)) {
                data.items.forEach(item => {
                  if (item.quantity === 1 && (!item.properties || (!item.properties._fabric_quantity && !item.properties._is_dupatta))) {
                    item.quantity = 100;
                    item.properties = item.properties || {};
                    item.properties._is_fabric = 'true';
                    item.properties._fabric_quantity = '1.00';
                    modified = true;
                  }
                });
              } else if (data.id && data.quantity == 1 && (!data.properties || (!data.properties._fabric_quantity && !data.properties._is_dupatta))) {
                data.quantity = 100;
                data.properties = data.properties || {};
                data.properties._is_fabric = 'true';
                data.properties._fabric_quantity = '1.00';
                modified = true;
              }
              if (modified) {
                options.body = JSON.stringify(data);
                args[1] = options;
              }
            } catch (e) {
              if (options.body.includes('quantity=1') && !options.body.includes('_fabric_quantity') && !options.body.includes('_is_dupatta')) {
                options.body = options.body.replace('quantity=1', 'quantity=100');
                options.body += '&properties[_is_fabric]=true&properties[_fabric_quantity]=1.00';
                args[1] = options;
              }
            }
          } else if (options.body instanceof FormData) {
            if (options.body.get('quantity') == '1' && !options.body.has('properties[_fabric_quantity]') && !options.body.has('properties[_is_dupatta]')) {
              options.body.set('quantity', '100');
              options.body.set('properties[_is_fabric]', 'true');
              options.body.set('properties[_fabric_quantity]', '1.00');
            }
          } else if (options.body instanceof URLSearchParams) {
            if (options.body.get('quantity') == '1' && !options.body.has('properties[_fabric_quantity]') && !options.body.has('properties[_is_dupatta]')) {
              options.body.set('quantity', '100');
              options.body.set('properties[_is_fabric]', 'true');
              options.body.set('properties[_fabric_quantity]', '1.00');
            }
          }
        }
      } catch (e) {
        console.error('Error intercepting fetch:', e);
      }
    }
    return originalFetch.apply(this, args);
  };

  const originalXHR = window.XMLHttpRequest;
  function interceptXHR() {
    const xhr = new originalXHR();
    const originalOpen = xhr.open;
    const originalSend = xhr.send;
    let reqUrl = '';
    xhr.open = function (method, url, ...rest) {
      reqUrl = url;
      return originalOpen.call(this, method, url, ...rest);
    };
    xhr.send = function (body) {
      if (reqUrl && typeof reqUrl === 'string' && (reqUrl.includes('/cart/add.js') || reqUrl.includes('/cart/add'))) {
        try {
          if (typeof body === 'string') {
            try {
              let data = JSON.parse(body);
              let modified = false;
              if (data.items && Array.isArray(data.items)) {
                data.items.forEach(item => {
                  if (item.quantity === 1 && (!item.properties || (!item.properties._fabric_quantity && !item.properties._is_dupatta))) {
                    item.quantity = 100;
                    item.properties = item.properties || {};
                    item.properties._is_fabric = 'true';
                    item.properties._fabric_quantity = '1.00';
                    modified = true;
                  }
                });
              } else if (data.id && data.quantity == 1 && (!data.properties || (!data.properties._fabric_quantity && !data.properties._is_dupatta))) {
                data.quantity = 100;
                data.properties = data.properties || {};
                data.properties._is_fabric = 'true';
                data.properties._fabric_quantity = '1.00';
                modified = true;
              }
              if (modified) {
                body = JSON.stringify(data);
              }
            } catch (e) {
              if (body.includes('quantity=1') && !body.includes('_fabric_quantity') && !body.includes('_is_dupatta')) {
                body = body.replace('quantity=1', 'quantity=100');
                body += '&properties[_is_fabric]=true&properties[_fabric_quantity]=1.00';
              }
            }
          } else if (body instanceof FormData) {
            if (body.get('quantity') == '1' && !body.has('properties[_fabric_quantity]') && !body.has('properties[_is_dupatta]')) {
              body.set('quantity', '100');
              body.set('properties[_is_fabric]', 'true');
              body.set('properties[_fabric_quantity]', '1.00');
            }
          } else if (body instanceof URLSearchParams) {
            if (body.get('quantity') == '1' && !body.has('properties[_fabric_quantity]') && !body.has('properties[_is_dupatta]')) {
              body.set('quantity', '100');
              body.set('properties[_is_fabric]', 'true');
              body.set('properties[_fabric_quantity]', '1.00');
            }
          }
        } catch (e) {
          console.error('Error intercepting XHR:', e);
        }
      }
      return originalSend.call(this, body);
    };
    return xhr;
  }
  if (window.XMLHttpRequest.name !== 'interceptXHR') {
    window.XMLHttpRequest = interceptXHR;
  }
})();

(function () {
  function fixSwymPrices() {
    // Selectors that might contain the price
    const containers = document.querySelectorAll(
      '.swym-wishlist-grid, .swym-wishlist-item, .swym-product-price, .swym-has-variant, [data-swym-product-id], .swym-wishlist-detail-separator, #swym-wishlist-render-container, .swym-ui-component, .swym-price, .swym-value, .swym-title-price-container, .swym-product-title-price'
    );

    function fixText(text) {
      if (!text) return text;
      // Regex matching currency symbol, raw price (< 100), and optional unit
      const priceRegex = /(₹|Rs\.?|INR)?\s*\.?\s*([0-9]+(?:\.[0-9]{1,2})?)\s*(\/Meter|\/meter)?/gi;
      return text.replace(priceRegex, (fullMatch, symbol, priceStr, unit) => {
        const priceNum = parseFloat(priceStr);
        if (priceNum > 0 && priceNum < 100) {
          const fixedPrice = (priceNum * 100).toFixed(2);

          // Only add symbol/unit if they were in the original string!
          // This prevents duplicating symbols if the text node only contains the number.
          let sym = '';
          if (symbol) {
            sym = symbol.trim();
            // Re-add the dot if it was in the original match (e.g. ₹.)
            if (fullMatch.includes(sym + '.')) {
              sym += '.';
            }
            sym += ' ';
          } else if (fullMatch.includes('₹.')) {
            sym = '₹. ';
          } else if (fullMatch.includes('Rs.')) {
            sym = 'Rs. ';
          } else if (fullMatch.includes('₹')) {
            sym = '₹ ';
          }

          const u = unit ? unit : '';
          return `${sym}${fixedPrice}${u}`;
        }
        return fullMatch;
      });
    }

    function processNode(node) {
      if (!node) return;
      if (node.dataset && node.dataset.swymPriceFixed === 'true') return;

      let modified = false;

      // Only process elements that are visible and likely to contain text
      if (node.nodeType === Node.ELEMENT_NODE) {
        // Walk through all text nodes inside this element
        const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null, false);
        let textNode;
        while ((textNode = walker.nextNode())) {
          const oldText = textNode.nodeValue;
          if (oldText && oldText.trim() !== '') {
            const newText = fixText(oldText);
            if (oldText !== newText) {
              textNode.nodeValue = newText;
              modified = true;
            }
          }
        }

        if (modified) {
          node.dataset.swymPriceFixed = 'true';
        }
      }
    }

    containers.forEach((container) => {
      // Process container itself
      processNode(container);
      // Process all descendants just in case
      container.querySelectorAll('*').forEach(processNode);
    });
  }

  // Run on DOM load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSwymPrices);
  } else {
    fixSwymPrices();
  }

  // Observe body for dynamic Swym element additions
  const observer = new MutationObserver((mutations) => {
    let shouldFix = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0 || mutation.type === 'characterData') {
        shouldFix = true;
        break;
      }
    }
    if (shouldFix) {
      fixSwymPrices();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true, characterData: true });

  // Hook into Swym's internal events
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    if (swat && swat.evt) {
      swat.evt.on(swat.evt.eventType.RENDER_WISHLIST, function () {
        setTimeout(fixSwymPrices, 50);
        setTimeout(fixSwymPrices, 200);
        setTimeout(fixSwymPrices, 600);
        setTimeout(fixSwymPrices, 1500);
      });
    }
  });

  // Aggressive polling on the wishlist page
  if (window.location.pathname.includes('swym-wishlist')) {
    setInterval(fixSwymPrices, 500);
  }
})();
